import { defineStore } from 'pinia';
import axiosInstance from '@/app/axios';

export const useSocialsStore = defineStore('socialsStore', {
  state: () => ({
    items: [],
    loading: false,
  }),
  actions: {
    async getItems(reset = false) {
      if (this.items.length && !reset && !this.loading) {
        return this.items;
      }
      this.loading = true;
      this.items = await axiosInstance
        .get('/lms/socials')
        .then((res) => res.data.data);
      this.loading = false;
    },
    reset() {
      this.getItems(true);
    },
  },
});
